"use client";

import { ReactNode } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { useAssignDialog } from "../Providers/AssignDialogContext";

interface DialogProps {
  children: ReactNode;
}

export default function Dialog({ children }: DialogProps) {
  const { assignDialogOpen, closeAssignDialog } = useAssignDialog();

  const handleClose = () => {
    closeAssignDialog();
  };

  return (
    <MuiDialog fullWidth open={assignDialogOpen} onClose={handleClose}>
      {children}
    </MuiDialog>
  );
}
